import { render, staticRenderFns } from "./InputDescription.vue?vue&type=template&id=2b54ad02&"
import script from "./InputDescription.vue?vue&type=script&lang=js&"
export * from "./InputDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b54ad02')) {
      api.createRecord('2b54ad02', component.options)
    } else {
      api.reload('2b54ad02', component.options)
    }
    module.hot.accept("./InputDescription.vue?vue&type=template&id=2b54ad02&", function () {
      api.rerender('2b54ad02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/InputDescription.vue"
export default component.exports